import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { loaderDisplayed } from 'actions/loaderDisplayed';

import {
  ANDROID_DOWNLOAD_LINK,
  IOS_DOWNLOAD_LINK,
  IS_PAY_ANYONE_P2P,
} from 'consts/appConsts';
import { IS_IOS, IS_MOBILE_DEVICE } from 'consts/platformConsts';
import { EMBEDDED_ACCEPT_DISMISS_ROUTE } from 'consts/routeConsts';

import { selectFormData } from 'selectors/form';

import { Button } from 'styles/Button';

import { dismissToLogin } from 'utils/linkHelper';
import { IS_EMBEDDED } from 'utils/queryParamHelpers';
import doRedirect from 'utils/redirectHelper';
import {
  trackEmbeddedCTATapEvent,
  trackSuccessPageDownloadCtaTapped,
} from 'utils/segment/trackingEvents';

import { SuccessQrCode } from './SuccessQrCode';

const NoMarginButton = styled(Button)`
  margin: 0;
`;

const EmbeddedCtaButton = ({ eventContext }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isReactNativeWebView = typeof window.ReactNativeWebView !== 'undefined';
  const label = 'Continue';

  const onEmbeddedCtaClick = () => {
    trackEmbeddedCTATapEvent(label, isReactNativeWebView, eventContext);
    dispatch(loaderDisplayed());
    if (isReactNativeWebView) {
      history.push(EMBEDDED_ACCEPT_DISMISS_ROUTE.path);
    } else {
      doRedirect(dismissToLogin, {});
    }
  };

  return <NoMarginButton onClick={onEmbeddedCtaClick}>{label}</NoMarginButton>;
};

EmbeddedCtaButton.propTypes = {
  eventContext: PropTypes.string,
};

const MobileCtaButton = ({
  children = `Download ${IS_PAY_ANYONE_P2P ? 'now' : ''}`,
  formData,
}) => {
  const downloadLink = IS_IOS ? IOS_DOWNLOAD_LINK : ANDROID_DOWNLOAD_LINK;

  const P2P_DOWNLOAD_LINK = 'https://chimebank.onelink.me/FYe7/f93972e9';

  const handleClick = () => {
    const ctaText = typeof children === 'string' ? children : 'Download Now';
    trackSuccessPageDownloadCtaTapped(ctaText, null, formData);
  };

  return (
    <NoMarginButton
      as="a"
      href={IS_PAY_ANYONE_P2P ? P2P_DOWNLOAD_LINK : downloadLink}
      onClick={handleClick}
    >
      {children}
    </NoMarginButton>
  );
};

MobileCtaButton.propTypes = {
  children: PropTypes.node,
  formData: PropTypes.object,
};

const SuccessPageButton = ({ eventContext, ...props }) => {
  const formData = useSelector(selectFormData, shallowEqual);

  if (IS_EMBEDDED) {
    // app enrollment
    return <EmbeddedCtaButton eventContext={eventContext} {...props} />;
  }

  if (IS_MOBILE_DEVICE) {
    // mobile browser enrollment
    return <MobileCtaButton {...props} formData={formData} />;
  }

  // desktop enrollment
  return <SuccessQrCode />;
};

SuccessPageButton.propTypes = {
  eventContext: PropTypes.string,
};

export default SuccessPageButton;
